module.exports = __webpack_public_path__ + "img/Albaraka Bank.dcd39a6e.png";